// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7zybe":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListViewContext", ()=>ListViewContext);
parcelHelpers.export(exports, "S2ListLayout", ()=>S2ListLayout);
parcelHelpers.export(exports, "ListView", ()=>ListView);
parcelHelpers.export(exports, "ListViewItem", ()=>ListViewItem);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _actionMenu = require("./ActionMenu");
var _centerBaseline = require("./CenterBaseline");
var _checkbox = require("./Checkbox");
var _checkbox1 = require("react-aria-components/Checkbox");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _collection = require("react-aria/Collection");
var _collectionBuilder = require("react-aria-components/CollectionBuilder");
var _slots = require("react-aria-components/slots");
var _react = require("react");
var _dragPreview = require("./DragPreview");
var _dndUtils = require("./dnd-utils");
var _gridList = require("react-aria-components/GridList");
var _icon = require("./Icon");
var _image = require("./Image");
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _virtualizer = require("react-aria-components/Virtualizer");
var _linkOut = require("../ui-icons/LinkOut");
var _linkOutDefault = parcelHelpers.interopDefault(_linkOut);
var _useVirtualizerState = require("react-stately/useVirtualizerState");
var _progressCircle = require("./ProgressCircle");
var _content = require("./Content");
var _actionBar = require("./ActionBar");
var _useDOMRef = require("./useDOMRef");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _utils = require("./utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ListViewContext = /*#__PURE__*/ (0, _react.createContext)(null);
let InternalListViewContext = /*#__PURE__*/ (0, _react.createContext)({});
const listViewWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let minWidth = false;
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma17';
    if (!minWidth) rules += ' NU2bf917';
    rules += ' sd17';
    rules += ' _Bb17';
    rules += ' __ca17';
    if (!position) rules += ' _Pc17';
    rules += ' _Nb17';
    rules += ' Pb17';
    rules += ' -qVUQke-oH5kTnc17';
    return rules;
};
// similar to tableview, use this approach so we can actually have a 2px outline when root dropping.
// cant do a external box shadow due to the clipping that is applied on the wrapper element...
// an inset box shadow runs into problems with the item background clipping the box shadow...
const rootDropOutline = "IJKxRb";
// When any row has a trailing icon, reserve space so actions align.
const hasTrailingIconRows = ':has([data-has-trailing-icon]) [role="row"]';
const dropTargetBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const listView = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    if (props.isQuiet) rules += ' _Ka17';
    else rules += ' _Kb17';
    rules += ' _4c17';
    rules += ' Ma17';
    rules += ' Na17';
    rules += ' Za17';
    rules += ' Fb17';
    rules += ' _oa17';
    rules += ' _Na17';
    rules += ' Pa17';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a17';
        rules += ' vFHT6Dd17';
    } else {
        rules += ' -_6BNtrc-c17';
        rules += ' vFHT6Dd17';
    }
    if (props.isDropTarget) {
        rules += ' glzvDBe17';
        rules += ' glOVIhfcceMNLe17';
        rules += ' glOVIhfcceMNLe17';
    } else if (props.isQuiet) rules += ' g917';
    else rules += ' gX17';
    if (props.isQuiet) rules += ' od17';
    else rules += ' oH5kTnc17';
    if (props.isQuiet) rules += ' nd17';
    else rules += ' nH5kTnc17';
    if (props.isQuiet) rules += ' kd17';
    else rules += ' kH5kTnc17';
    if (props.isQuiet) rules += ' jd17';
    else rules += ' jH5kTnc17';
    rules += ' iq17';
    rules += ' ilOVIhfcCp4usd17';
    rules += ' ilOVIhfcCp4usd17';
    if (props.isQuiet) rules += ' _ka17';
    else rules += ' _kb17';
    if (props.isQuiet) rules += ' ha17';
    else rules += ' hb17';
    if (props.isQuiet) rules += ' ma17';
    else rules += ' mb17';
    if (props.isQuiet) rules += ' la17';
    else rules += ' lb17';
    rules += ' _jf17';
    rules += ' _yb17';
    rules += ' -Ev4N4b-Zd17';
    rules += ' -Ev4N4b-1bNH0cZObNfn17';
    return rules;
};
class S2ListLayout extends (0, _useVirtualizerState.ListLayout) {
    getDropTargetLayoutInfo(target) {
        let layoutInfo = super.getDropTargetLayoutInfo(target);
        layoutInfo.zIndex = 1;
        layoutInfo.allowOverflow = true;
        return layoutInfo;
    }
}
const ListView = /*#__PURE__*/ (0, _react.forwardRef)(function ListView(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ListViewContext);
    let { children, isQuiet, selectionStyle = 'checkbox', overflowMode = 'truncate', loadingState, onLoadMore, renderEmptyState: userRenderEmptyState, hideLinkOutIcon = false, dragAndDropHooks, ...otherProps } = props;
    let scale = (0, _utils.useScale)();
    if (dragAndDropHooks && dragAndDropHooks.renderDragPreview == null) dragAndDropHooks.renderDragPreview = (items)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragPreview.DragPreview), {
            items: items,
            overflowMode: overflowMode
        });
    if (dragAndDropHooks) dragAndDropHooks.renderDropIndicator = (target)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dndUtils.InsertionIndicator), {
            target: target
        });
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    let rowHeight = scale === 'large' ? 50 : 40;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let scrollRef = (0, _react.useRef)(null);
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let renderEmptyState;
    if (userRenderEmptyState != null && !isLoading) renderEmptyState = (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: emptyStateWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionBuilder.CollectionRendererContext).Provider, {
                value: (0, _collectionBuilder.DefaultCollectionRenderer),
                children: userRenderEmptyState(renderProps)
            })
        });
    else if (loadingState === 'loading') renderEmptyState = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: loadingSpinnerWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('table.loading')
                })
            })
        });
    let loadMoreSpinner = onLoadMore ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridListLoadMoreItem), {
        isLoading: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        className: " Fb17 Za17 Tt17 Qt17",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: centeredWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: loadingSpinnerWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": stringFormatter.format('table.loadingMore')
                })
            })
        })
    }) : null;
    let wrappedChildren;
    let gridListProps = otherProps;
    if (typeof children === 'function' && otherProps.items) {
        let { items, dependencies = [], ...rest } = otherProps;
        gridListProps = rest;
        wrappedChildren = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collection.Collection), {
                    items: items,
                    dependencies: dependencies,
                    children: children
                }),
                loadMoreSpinner
            ]
        });
    } else wrappedChildren = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            loadMoreSpinner
        ]
    });
    let { selectedKeys, onSelectionChange, actionBar, actionBarHeight } = (0, _actionBar.useActionBarContainer)({
        ...props,
        scrollRef
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: domRef,
        className: (props.UNSAFE_className || '') + listViewWrapper(null, props.styles) + ' ' + rootDropOutline,
        style: props.UNSAFE_style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _virtualizer.Virtualizer), {
                layout: S2ListLayout,
                layoutOptions: {
                    estimatedRowHeight: rowHeight,
                    loaderHeight: 60,
                    dropIndicatorThickness: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalListViewContext.Provider, {
                    value: {
                        isQuiet,
                        selectionStyle,
                        overflowMode,
                        scale,
                        hideLinkOutIcon
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
                        ref: scrollRef,
                        ...gridListProps,
                        dragAndDropHooks: dragAndDropHooks,
                        selectionBehavior: selectionStyle === 'highlight' ? 'replace' : 'toggle',
                        selectionMode: gridListProps.selectionMode,
                        renderEmptyState: renderEmptyState,
                        style: {
                            paddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0,
                            scrollPaddingBottom: actionBarHeight > 0 ? actionBarHeight + 8 : 0
                        },
                        className: (renderProps)=>listView({
                                ...renderProps,
                                isQuiet,
                                isDropTarget: renderProps.isDropTarget
                            }),
                        selectedKeys: selectedKeys,
                        defaultSelectedKeys: undefined,
                        onSelectionChange: onSelectionChange,
                        children: wrappedChildren
                    })
                })
            }),
            actionBar
        ]
    });
});
const selectedBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 7%)]";
const selectedActiveBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(19, 19, 19), rgb(242, 242, 242)) 10%)]";
// TODO: removed the background color in HCM for highlight selection since it made it hard to see the focus
// ring of the drag button, this matches v3 anyways. thoughts?
const listitem = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") {
        rules += ' uk17';
        rules += ' ucJ9TBTb17';
        rules += ' ud3Euai17';
        rules += ' uea17';
        rules += ' ugb17';
        rules += ' uhd17';
        rules += ' uje17';
        rules += ' u2NhKxcl17';
        rules += ' uic17';
    } else if (props.size === "L") {
        rules += ' uk17';
        rules += ' ucJ9TBTb17';
        rules += ' ud3Euai17';
        rules += ' uea17';
        rules += ' ugb17';
        rules += ' uhd17';
        rules += ' uje17';
        rules += ' u2NhKxcl17';
        rules += ' uic17';
    } else if (props.size === "S") {
        rules += ' uk17';
        rules += ' ucJ9TBTb17';
        rules += ' ud3Euai17';
        rules += ' uea17';
        rules += ' ugb17';
        rules += ' uhd17';
        rules += ' uje17';
        rules += ' u2NhKxcl17';
        rules += ' uic17';
    } else if (props.size === "XS") {
        rules += ' uk17';
        rules += ' ucJ9TBTb17';
        rules += ' ud3Euai17';
        rules += ' uea17';
        rules += ' ugb17';
        rules += ' uhd17';
        rules += ' uje17';
        rules += ' u2NhKxcl17';
        rules += ' uic17';
    } else {
        rules += ' uk17';
        rules += ' ucJ9TBTb17';
        rules += ' ud3Euai17';
        rules += ' uea17';
        rules += ' ugb17';
        rules += ' uhd17';
        rules += ' uje17';
        rules += ' u2NhKxcl17';
        rules += ' uic17';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a17';
        rules += ' vFHT6Dd17';
    } else {
        rules += ' -_6BNtrc-c17';
        rules += ' vFHT6Dd17';
    }
    if (props.size === "XL") {
        rules += ' xb17';
        rules += ' _xa17';
    } else if (props.size === "L") {
        rules += ' xb17';
        rules += ' _xa17';
    } else if (props.size === "S") {
        rules += ' xb17';
        rules += ' _xa17';
    } else if (props.size === "XS") {
        rules += ' xb17';
        rules += ' _xa17';
    } else {
        rules += ' xb17';
        rules += ' _xa17';
    }
    if (props.size === "XL") {
        rules += ' _Fd17';
        rules += ' _FnuYUweb17';
    } else if (props.size === "L") {
        rules += ' _Fd17';
        rules += ' _FnuYUweb17';
    } else if (props.size === "S") {
        rules += ' _Fd17';
        rules += ' _FnuYUweb17';
    } else if (props.size === "XS") {
        rules += ' _Fd17';
        rules += ' _FnuYUweb17';
    } else {
        rules += ' _Fd17';
        rules += ' _FnuYUweb17';
    }
    if (props.isDisabled) rules += ' pp17';
    else if (props.isSelected) {
        if (props.isPressed) rules += ' po17';
        else if (props.isFocusVisible) rules += ' po17';
        else if (props.isHovered) rules += ' po17';
        else rules += ' pt17';
    } else {
        if (props.isPressed) rules += ' pt17';
        else if (props.isFocusVisible) rules += ' pt17';
        else if (props.isHovered) rules += ' pt17';
        else rules += ' pv17';
    }
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else if (props.isSelected) {
        if (props.selectionStyle === "highlight") rules += ' plOVIhfcgp5Dcd17';
    } else rules += ' plOVIhfc6LxY917';
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else if (props.isSelected) {
        if (props.selectionStyle === "highlight") rules += ' plOVIhfcgp5Dcd17';
    } else rules += ' plOVIhfc6LxY917';
    rules += ' _Le17';
    rules += ' _oa17';
    rules += ' qYB8I17';
    rules += ' Sd17';
    rules += ' Rd17';
    rules += ' Tt17';
    rules += ' Qt17';
    rules += ' g917';
    rules += ' _Pc17';
    rules += ' z2mU17';
    rules += ' yzZKy17';
    rules += ' se17';
    rules += ' CTJxasc17';
    rules += ' DBbiXc17';
    rules += ' Exumf9b17';
    rules += ' UDNKd2dPTu94b17';
    rules += ' ea17';
    if (props.scale === "large") rules += ' M7PUgr17';
    else rules += ' M3JjxG17';
    rules += ' _Xa17';
    if (props.isLink) rules += ' ry17';
    else rules += ' ri17';
    if (props.isSelected) {
        if (props.selectionStyle === "checkbox") rules += ' -EH8uVb-iq17';
        else if (props.selectionStyle === "highlight") {
            rules += ' -EH8uVb-iw17';
            rules += ' -EH8uVb-lOVIhfciebS7sd17';
            rules += ' -EH8uVb-lOVIhfciebS7sd17';
        }
    } else {
        rules += ' -EH8uVb-iq17';
        rules += ' -EH8uVb-lOVIhfciCp4usd17';
        rules += ' -EH8uVb-lOVIhfciCp4usd17';
    }
    rules += ' _ka17';
    if (props.isLastItem) {
        if (props.isQuiet) rules += ' ha17';
        else rules += ' hb17';
    } else rules += ' hb17';
    rules += ' ma17';
    rules += ' la17';
    rules += ' _jf17';
    if (props.isSelected) rules += ' iA17';
    else if (props.isNextSelected) rules += ' iA17';
    else rules += ' i4pzfu17';
    rules += ' ilOVIhfcCp4usd17';
    rules += ' ilOVIhfcCp4usd17';
    rules += ' -Bu7z1c-oH5kTnc17';
    rules += ' _yb17';
    return rules;
};
const insetBorderRadius = 'calc(var(--radius) - 1px)';
const rootDropSelectedRowBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 28%)]";
const rowDropBackground = "[color-mix(in srgb, light-dark(rgb(255, 255, 255), rgb(17, 17, 17)), light-dark(rgb(59, 99, 251), rgb(86, 129, 255)) 10%)]";
const rootRowDropStyles = {
    // Unlike v3 tableview, v3 listview has the same background color for the listview itself and the rows when
    // dropping on root
    default: dropTargetBackground,
    isSelected: rootDropSelectedRowBackground,
    forcedColors: 'Background'
};
const rowDropStyles = {
    // Also unlike v3, dropping on a selected row vs a non selected row doesn't have any difference in background color
    default: rowDropBackground,
    isSelected: rowDropBackground,
    forcedColors: 'Background'
};
const listRowBackground = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa17';
    rules += ' _9a17';
    if (props.isFirstItem) rules += ' Wr17';
    else if (props.isPrevSelected) rules += ' Wr17';
    else if (props.isSelected) rules += ' WLPOtrc17';
    else rules += ' Wr17';
    rules += ' WlOVIhfcr17';
    rules += ' WlOVIhfcr17';
    rules += ' _Er17';
    rules += ' _Rr17';
    if (props.isSelected) rules += ' _lLPOtrc17';
    else rules += ' _lr17';
    if (props.isDropTarget) {
        if (props.isSelected) rules += ' glzvDBe17';
        else rules += ' glzvDBe17';
        rules += ' glOVIhfcceMNLe17';
        rules += ' glOVIhfcceMNLe17';
    } else {
        if (props.isSelected) {
            if (props.selectionStyle === "highlight") {
                if (props.isPressed) rules += ' gaZwDBe17';
                else if (props.isHovered) rules += ' gaZwDBe17';
                else rules += ' glzvDBe17';
            } else if (props.selectionStyle === "checkbox") {
                if (props.isFocusVisible) rules += ' gRfT7e17';
                else if (props.isPressed) rules += ' gRfT7e17';
                else if (props.isHovered) rules += ' gRfT7e17';
                else rules += ' gj1B7i17';
            }
        } else if (props.isPressed) {
            if (props.selectionStyle === "checkbox") rules += ' gRfT7e17';
            else rules += ' g7IonAe17';
        } else if (props.isHovered) {
            if (props.selectionStyle === "checkbox") rules += ' gj1B7i17';
            else rules += ' gVQkD8c17';
        } else rules += ' gs9yXOb17';
        if (props.selectionStyle === "highlight") {
            if (props.isSelected) rules += ' glOVIhfcebS7sd17';
            else rules += ' glOVIhfc917';
        } else rules += ' glOVIhfc917';
        if (props.selectionStyle === "highlight") {
            if (props.isSelected) rules += ' glOVIhfcebS7sd17';
            else rules += ' glOVIhfc917';
        } else rules += ' glOVIhfc917';
        if (props.isSelected) rules += ' gRQaNpdubHDBe17';
        else rules += ' gRQaNpdlzvDBe17';
        rules += ' gRQaNpdlOVIhfcceMNLe17';
        rules += ' gRQaNpdlOVIhfcceMNLe17';
    }
    if (props.isDropTarget) rules += ' o7E7Gic17';
    else if (props.isPrevNotSelected) {
        if (props.isQuiet) rules += ' oH5kTnc17';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' o7E7Gic17';
            else if (props.selectionStyle === "checkbox") rules += ' od17';
        }
    } else if (props.isSelected) rules += ' od17';
    else if (props.isQuiet) rules += ' oH5kTnc17';
    if (props.isDropTarget) rules += ' n7E7Gic17';
    else if (props.isPrevNotSelected) {
        if (props.isQuiet) rules += ' nH5kTnc17';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' n7E7Gic17';
            else if (props.selectionStyle === "checkbox") rules += ' nd17';
        }
    } else if (props.isSelected) rules += ' nd17';
    else if (props.isQuiet) rules += ' nH5kTnc17';
    if (props.isDropTarget) rules += ' k7E7Gic17';
    else if (props.isNextNotSelected) {
        if (props.isQuiet) rules += ' kH5kTnc17';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' k7E7Gic17';
            else if (props.selectionStyle === "checkbox") rules += ' kd17';
        }
    } else if (props.isSelected) rules += ' kd17';
    else if (props.isQuiet) rules += ' kH5kTnc17';
    if (props.isDropTarget) rules += ' j7E7Gic17';
    else if (props.isNextNotSelected) {
        if (props.isQuiet) rules += ' jH5kTnc17';
        else if (props.isSelected) {
            if (props.selectionStyle === "highlight") rules += ' j7E7Gic17';
            else if (props.selectionStyle === "checkbox") rules += ' jd17';
        }
    } else if (props.isSelected) rules += ' jd17';
    else if (props.isQuiet) rules += ' jH5kTnc17';
    if (props.isDropTarget) rules += ' _kc17';
    else if (props.isPrevSelected) rules += ' _ka17';
    else {
        if (props.selectionStyle === "highlight") rules += ' _kb17';
        else if (props.selectionStyle === "checkbox") rules += ' _ka17';
    }
    if (props.isDropTarget) rules += ' hc17';
    else if (props.isNextSelected) rules += ' ha17';
    else {
        if (props.selectionStyle === "highlight") rules += ' hb17';
        else if (props.selectionStyle === "checkbox") rules += ' ha17';
    }
    if (props.isDropTarget) rules += ' mc17';
    else {
        if (props.selectionStyle === "highlight") rules += ' mb17';
        else if (props.selectionStyle === "checkbox") rules += ' ma17';
    }
    if (props.isDropTarget) rules += ' lc17';
    else {
        if (props.selectionStyle === "highlight") rules += ' lb17';
        else if (props.selectionStyle === "checkbox") rules += ' la17';
    }
    rules += ' _jf17';
    if (props.isDropTarget) rules += ' ix17';
    else if (props.isSelected) {
        if (props.selectionStyle === "highlight") rules += ' i4pzfu17';
        else if (props.selectionStyle === "checkbox") rules += ' iA17';
    } else rules += ' iA17';
    if (props.isDropTarget) rules += ' ilOVIhfcebS7sd17';
    if (props.isDropTarget) rules += ' ilOVIhfcebS7sd17';
    return rules;
};
let listRowFocusRing = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    if (props.selectionStyle === "highlight") rules += ' OlOVIhfcCp4usd17';
    else rules += ' OlOVIhfcebS7sd17';
    if (props.selectionStyle === "highlight") rules += ' OlOVIhfcCp4usd17';
    else rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    rules += ' _MlOVIhfckNNfn17';
    rules += ' _MlOVIhfckNNfn17';
    rules += ' _Kb17';
    rules += ' _KlOVIhfcToPtrc17';
    rules += ' _KlOVIhfcToPtrc17';
    rules += ' _Pa17';
    if (props.isFirstItem) rules += ' Wr17';
    else rules += ' WLPOtrc17';
    if (props.selectionStyle === "highlight") rules += ' _lLPOtrc17';
    else if (props.selectionStyle === "checkbox") {
        if (props.isNextSelected) rules += ' _lr17';
        else rules += ' _lLPOtrc17';
    }
    rules += ' _Ar17';
    rules += ' _zr17';
    if (props.isQuiet) rules += ' oH5kTnc17';
    else rules += ' o7E7Gic17';
    if (props.isQuiet) rules += ' nH5kTnc17';
    else rules += ' n7E7Gic17';
    if (props.isQuiet) rules += ' kH5kTnc17';
    else rules += ' k7E7Gic17';
    if (props.isQuiet) rules += ' jH5kTnc17';
    else rules += ' j7E7Gic17';
    rules += ' _9c17';
    rules += ' _Ob17';
    return rules;
};
let rowWrapper = " sc17";
let image = " z2U5Crc17 y2U5Crc17 B2U5Crc17 AvoofG17 Ht17 Hsu17 _dc17 oR3ltQc17 nR3ltQc17 kR3ltQc17 jR3ltQc17 Z4dY0ec17 fa17 _Hb17";
let actionButtonGroup = " zkG38H17 ykG38H17 BkG38H17 AvoofG17 _dc17 __Ac17 It17 Isu17";
let listActionMenu = " z6Nrfjc17 y6Nrfjc17 B6Nrfjc17 AvoofG17 _dc17";
const listCheckbox = function anonymous(props) {
    let rules = " ";
    rules += ' z2CW8rb17';
    rules += ' y2CW8rb17';
    rules += ' B2CW8rb17';
    rules += ' AvoofG17';
    rules += ' _dc17';
    rules += ' HH5kTnc17';
    if (props.isDisabled) rules += ' _6b17';
    else rules += ' _6c17';
    return rules;
};
const listTrailingIcon = " znWsohc17 ynWsohc17 BnWsohc17 AvoofG17 _dc17 sd17 eb17 It17 Isu17";
let dragButtonContainer = " zdYeQw17 ydYeQw17 BdYeQw17 AvoofG17 _dc17 sd17 eb17 ZDldWXb17";
const centeredWrapper = " sd17 eb17 _Ca17 Za17 Fb17";
const loadingSpinnerWrapper = " TR3ltQc17 QR3ltQc17 SR3ltQc17 RR3ltQc17";
const emptyStateWrapper = " sd17 eb17 _Ca17 Za17 Fb17 _oa17 Tf17 Qf17 Sf17 Rf17";
function ListSelectionCheckbox({ isDisabled }) {
    let selectionContext = (0, _slots.useSlottedContext)((0, _checkbox1.CheckboxContext), 'selection');
    let isSelectionDisabled = isDisabled || !!selectionContext?.isDisabled;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: listCheckbox({
            isDisabled: isSelectionDisabled
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
            slot: "selection"
        })
    });
}
function ListViewItem(props1) {
    let ref = (0, _react.useRef)(null);
    let { hasChildItems, ...otherProps } = props1;
    let isLink = props1.href != null;
    let isLinkOut = isLink && props1.target === '_blank';
    let { isQuiet, selectionStyle, overflowMode, scale, hideLinkOutIcon = false } = (0, _react.useContext)(InternalListViewContext);
    let textValue = props1.textValue || (typeof props1.children === 'string' ? props1.children : undefined);
    let { direction } = (0, _i18Nprovider.useLocale)();
    let hasTrailingIcon = hasChildItems || isLinkOut && !hideLinkOutIcon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridListItem), {
        ...otherProps,
        textValue: textValue,
        ref: ref,
        ...hasTrailingIcon ? {
            'data-has-trailing-icon': ''
        } : {},
        className: (renderProps)=>listitem({
                ...renderProps,
                isLink,
                isQuiet,
                scale,
                selectionStyle,
                isPrevNotSelected: !isPrevSelected(renderProps.id, renderProps.state),
                isNextSelected: isNextSelected(renderProps.id, renderProps.state),
                isNextNotSelected: !isNextSelected(renderProps.id, renderProps.state),
                isFirstItem: isFirstItem(renderProps.id, renderProps.state),
                isLastItem: isLastItem(renderProps.id, renderProps.state)
            }),
        children: (renderProps)=>{
            let { children } = props1;
            let { selectionMode, selectionBehavior, isDisabled, id, state, allowsDragging, isFocusVisibleWithin } = renderProps;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                values: [
                    [
                        (0, _content.TextContext),
                        {
                            slots: {
                                [(0, _slots.DEFAULT_SLOT)]: {
                                    styles: (0, _dragPreview.label)({
                                        ...renderProps,
                                        overflowMode
                                    })
                                },
                                label: {
                                    styles: (0, _dragPreview.label)({
                                        ...renderProps,
                                        overflowMode
                                    })
                                },
                                description: {
                                    styles: (0, _dragPreview.description)({
                                        ...renderProps,
                                        overflowMode
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, _icon.IconContext),
                        {
                            slots: {
                                icon: {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: (0, _dragPreview.iconCenterWrapper)
                                    }),
                                    styles: (0, _dragPreview.icon)
                                }
                            }
                        }
                    ],
                    [
                        (0, _image.ImageContext),
                        {
                            styles: image
                        }
                    ],
                    [
                        (0, _actionButtonGroup.ActionButtonGroupContext),
                        {
                            styles: actionButtonGroup,
                            size: 'S',
                            isQuiet: true
                        }
                    ],
                    [
                        (0, _actionMenu.ActionMenuContext),
                        {
                            styles: listActionMenu,
                            isQuiet: true,
                            size: 'S',
                            isDisabled
                        }
                    ]
                ],
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: rowWrapper,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: listRowBackground({
                                ...renderProps,
                                selectionStyle,
                                isQuiet,
                                isDropTarget: renderProps.isDropTarget,
                                isPrevSelected: isPrevSelected(id, state),
                                isNextSelected: isNextSelected(id, state),
                                isPrevNotSelected: !isPrevSelected(id, state),
                                isNextNotSelected: !isNextSelected(id, state),
                                isFirstItem: isFirstItem(id, state),
                                isLastItem: isLastItem(id, state)
                            })
                        }),
                        renderProps.isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: listRowFocusRing({
                                ...renderProps,
                                selectionStyle,
                                isQuiet,
                                isPrevSelected: isPrevSelected(id, state),
                                isNextSelected: isNextSelected(id, state),
                                isPrevNotSelected: !isPrevSelected(id, state),
                                isNextNotSelected: !isNextSelected(id, state),
                                isFirstItem: isFirstItem(id, state),
                                isLastItem: isLastItem(id, state)
                            })
                        }),
                        allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: dragButtonContainer,
                            children: !isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dndUtils.DragHandleButton), {
                                isFocusVisibleWithin: isFocusVisibleWithin
                            })
                        }),
                        selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSelectionCheckbox, {
                            isDisabled: isDisabled
                        }),
                        typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            slot: "label",
                            children: children
                        }) : children,
                        isLinkOut && !hideLinkOutIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: listTrailingIcon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOutDefault.default), {
                                size: "M",
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a17';
                                        rules += ' __Ha17';
                                    }
                                    rules += ' -_8sjo0b-t5ZbAob17';
                                    return rules;
                                }({
                                    direction
                                })
                            })
                        }),
                        hasChildItems && !isLinkOut && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: listTrailingIcon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                                className: function anonymous(props) {
                                    let rules = " ";
                                    if (props.direction === "rtl") {
                                        rules += ' -Z4Pn4c-a17';
                                        rules += ' __Ha17';
                                    } else if (props.direction === "ltr") {
                                        rules += ' -Z4Pn4c-b17';
                                        rules += ' __Ha17';
                                    }
                                    if (props.direction === "rtl") {
                                        rules += ' -_04Pn4c-a17';
                                        rules += ' __Ha17';
                                    } else if (props.direction === "ltr") {
                                        rules += ' -_04Pn4c-b17';
                                        rules += ' __Ha17';
                                    }
                                    rules += ' -_8sjo0b-t5ZbAob17';
                                    return rules;
                                }({
                                    direction
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
}
function isNextSelected(id, state) {
    if (id == null || !state) return false;
    let keyAfter = state.collection.getKeyAfter(id);
    return keyAfter != null && state.selectionManager.isSelected(keyAfter);
}
function isPrevSelected(id, state) {
    if (id == null || !state) return false;
    let keyBefore = state.collection.getKeyBefore(id);
    return keyBefore != null && state.selectionManager.isSelected(keyBefore);
}
function isFirstItem(id, state) {
    if (id == null || !state) return false;
    return state.collection.getFirstKey() === id;
}
function isLastItem(id, state) {
    if (id == null || !state) return false;
    let key = state.collection.getLastKey();
    let node = key ? state.collection.getItem(key) : null;
    return node ? node.key === id : false;
}

},{"0":"kHxtO","1":"3YQYL","2":"FQfnh","3":"f2UwM","4":"d9D3F","5":"5mcu0","6":"8mCoO","7":"dyMVu","8":"hTqZl","9":"ii0qZ","10":"1XBiH","11":"iyBbh","12":"cbakQ","13":"gGKu8","14":"5xPuu","15":"3txJh","16":"hcvRl","17":"as0io","18":"hjW5j","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","./ActionMenu":"3fSPo","./CenterBaseline":"1vpL9","./Checkbox":"jdSVu","react-aria-components/Checkbox":"9jC2J","../ui-icons/Chevron":"1904U","react-aria/Collection":"3m036","react-aria-components/CollectionBuilder":"7QyMy","react-aria-components/slots":"bA6Cz","react":"a1TxN","./DragPreview":"cHtqj","./dnd-utils":"942YI","react-aria-components/GridList":"8bLgh","./Icon":"jQAJE","./Image":"4LTiE","../intl/*.json":"gDH3q","react-aria-components/Virtualizer":"2WSF6","../ui-icons/LinkOut":"6y2C0","react-stately/useVirtualizerState":"GXdVA","./ProgressCircle":"dztOy","./Content":"10r6w","./ActionBar":"gU4lG","./useDOMRef":"9tqah","react-aria/I18nProvider":"l34Wn","react-aria/useLocalizedStringFormatter":"4LM0k","./utils":"9papc","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kHxtO":[function() {},{}],"3YQYL":[function() {},{}],"FQfnh":[function() {},{}],"f2UwM":[function() {},{}],"d9D3F":[function() {},{}],"5mcu0":[function() {},{}],"8mCoO":[function() {},{}],"dyMVu":[function() {},{}],"hTqZl":[function() {},{}],"ii0qZ":[function() {},{}],"1XBiH":[function() {},{}],"iyBbh":[function() {},{}],"cbakQ":[function() {},{}],"gGKu8":[function() {},{}],"5xPuu":[function() {},{}],"3txJh":[function() {},{}],"hcvRl":[function() {},{}],"as0io":[function() {},{}],"hjW5j":[function() {},{}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ActionBar.a0dec4c3.js.map
